import { CountryCode, CurrencyCode } from './countries'
import { BillingPeriod, PaymentMethod } from './subscriptions'
import { SubscriptionsEstimateResponse } from '~/types/prices'

export enum CheckoutAddonType {
  CLOUD_DESIGNER = 'CLOUDDESIGNER',
}

export type Addon = {
  type: string
  numberOfPrinters: number
}

export type CheckoutData = {
  addons: Addon[]
  city?: string
  companyName?: string
  country?: CountryCode
  dunsNumber?: string
  partnerId?: string
  phoneNumber?: string
  postalCode?: string
  state?: string
  street?: string
  vatNumber?: string
}

export type CheckoutAccount = {
  numOfPrinters?: number
  partnerId: string
}

export type CheckoutPrices = {
  MONTHLY: Partial<SubscriptionsEstimateResponse>
  YEARLY: Partial<SubscriptionsEstimateResponse>
}

export type CheckoutCompletePayload = {
  currencyCode: CurrencyCode
  billingPeriod: BillingPeriod
  billingCountry?: CountryCode
  billingVatNumber?: string
  billingCompanyName?: string
  billingState?: string
  billingStreet?: string
  billingCity?: string
  billingPostalCode?: string
  paymentMethod?: PaymentMethod
  paymentToken?: string
}

export enum PrinterCountAction {
  ADD = 'add',
  REMOVE = 'remove',
}
